import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ContactanosModel} from '../models/contactanos.model';
import {AppConfig} from '../AppConfig';
import { ContactarAgente } from '../models/contactar-agente.model';

@Injectable({
    providedIn: 'root'
  })
  export class Contactanoservice {
  motivosContacto() {
    throw new Error('Method not implemented.');
  }
  guardarSolicitud(payLoadOportunidad: ContactarAgente) {
    throw new Error('Method not implemented.');
  }

    headers = new HttpHeaders({'Content-Type':'application/json'});
      //endopoint = 'http://localhost:7001/Inmuebles-0.0.1/bnt/inmuebles/nuevaCazaOportunidad';
      endpoint = '';
    
      constructor(private http:HttpClient, private appConfig: AppConfig) {
        this.endpoint = appConfig.getConfig('base_url');
      }
    
      guardarNuevaOportunidad(contactanosModel: ContactanosModel){
        return this.http.post(`${this.endpoint}/bnt/inmuebles/nuevaContactanos`,contactanosModel,{headers:this.headers});
      }
  }